import React from 'react';
import ReactDOM from 'react-dom/client';
import Placeholder from './Placeholder';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Placeholder />);